require("component-leaflet-map");
const dataJSON = require("../regionMap.json");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

const data = window.data;

var all2022Schools = data.filter(function (d) {
 return d.Year === "2022-2023";
});



var markers = [];
var markergroup = L.featureGroup();

var geojson = L.geoJson(dataJSON, {
}).addTo(map);



// geojson.eachLayer(function(featureInstanceLayer) {
//     featureInstanceLayer.setStyle({
//         fillColor: 'blue',
//         opacity: .25,
//         color: '#000',
//         fillOpacity: 0.8,
//         weight: 1
//     });
// });


all2022Schools.forEach(function(school) {
  var school_name = school.ID;
  school_name = school_name.replace(/\s/g, '');
  school_name = school_name.replace(/[^a-zA-Z0-9]/g, '');

  var marker = L.marker([school.latitude, school.longitude], {
    icon: L.divIcon({
      className: `school ${school_name}`
    })
  });

  markers.push(marker);
  marker.addTo(markergroup);
});

markergroup.addTo(map);
map.scrollWheelZoom.disable();

var zoom = document.querySelector("#card").offsetWidth < 480 ? 9 : 10;
map.setView(new L.LatLng(47.61097961360347, -122.34059603017335), zoom);

module.exports = geojson;
